// extracted by mini-css-extract-plugin
module.exports = {"no-image":"NoImages_no-image__k_rdB"};